import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 350px;
  margin: 0 auto;
  padding: 12px 0;
`;

export const SliderLabels = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;

  .label-points {
    color: var(--primary-color, #24283E);
  }

  .label-money {
    color: #96143C;
  }
`;

export const SliderTrack = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 8px;
  background-color: #E0E0E0;
  border-radius: 4px;
  overflow: visible;
`;

export const SliderSegment = styled.div`
  height: 100%;
  flex-shrink: 0;

  /* Segmento de Pontos (primary color) - sempre à esquerda */
  &.segment-points {
    background-color: var(--primary-color, #24283E);
    border-radius: 4px 0 0 4px;
  }

  /* Segmento de Valor a Pagar (vermelho) - à direita */
  &.segment-money {
    background-color: #96143C;
    border-radius: 0 4px 4px 0;
  }

  /* Quando é o primeiro segmento */
  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  /* Quando é o último segmento */
  &:last-of-type {
    border-radius: 0 4px 4px 0;
  }

  /* Quando é o único segmento */
  &:only-of-type {
    border-radius: 4px;
  }
`;

export const SliderThumb = styled.div`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #FFFFFF;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transform: translateX(-50%);
  top: 50%;
  margin-top: -11px;
  z-index: 10;
  pointer-events: none;

  /* Thumb de Pontos (primary color) */
  &.thumb-points {
    border: 2px solid var(--primary-color, #24283E);
  }

  /* Thumb de Valor a Pagar (vermelho) */
  &.thumb-money {
    border: 2px solid #96143C;
  }
`;

export const SliderValues = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 600;

  .separator {
    color: #767F8D;
    padding: 0 2px;
  }
`;

export const ValueItem = styled.span`
  /* Valor em Pontos (primary color) */
  &.value-points {
    color: var(--primary-color, #24283E);
    border-bottom: 1.5px solid var(--primary-color, #24283E);
  }

  /* Valor a Pagar (vermelho) */
  &.value-money {
    color: #96143C;
    border-bottom: 1.5px solid #96143C;
  }
`;
